export type Page =
  | 'Home'
  | 'About'
  | 'Team'
  | 'Events'
  | 'Gallery'
  | 'Blog'
  | 'Community'
  | 'Contact'
  | 'Support'
  | 'BlogDetails'
  | 'EventDetails';

export const NAV_LINKS: { name: Page; path: string }[] = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Team', path: '/team' },
  { name: 'Events', path: '/events' },
  // { name: 'Gallery', path: '/gallery' },
  // { name: 'Blog', path: '/blog' },
  // { name: 'Community', path: '/community' },
  { name: 'Contact', path: '/contact' },
  { name: 'Support', path: '/support' },
];

export interface Instructor {
  id: number;
  name: string;
  role: string;
  company?: string | null;
  email?: string | null;
  bio?: string | null;
  avatar_url?: string | null;
}

export interface MediaItem {
  id: number;
  title: string;
  caption: string;
  media_type: 'image' | 'video' | 'document';
  attachment_url: string;
}

export interface Event {
  id: number;
  title: string;
  slug: string;
  start_time: string;
  end_time: string;
  time_zone: string;
  location: string;
  status: 'draft' | 'published' | 'archived';
  external_registration_url: string;
  description: { body: string } | null; // Rich text (Action Text); body is HTML, present on the details page
  plain_text_description: string;
  details: any; // This will be HTML content from Action Text
  plain_text_details: string;
  pricing: any; // JSONB field
  registration_info: any; // JSONB field
  agenda: { time: string; topic: string }[] | null; // ordered by time, served by the model

  image_url: string | null;
  instructors: Instructor[];
  media_items: MediaItem[];
}
